import { Command } from '@/app/tracking/api';
import { SectionStatus } from '../api';

export interface UpdateSectionStateCommandPayload {
  sectionId: string;
  progress: {
    completion: number;
    scroll: number;
    page: number;
  };
  status: SectionStatus;
}

export const UpdateSectionStateCommandName = 'update-section-state' as const;

export type UpdateSectionStateCommand =
      Command<typeof UpdateSectionStateCommandName, UpdateSectionStateCommandPayload>;
